import {
  IconChevronLeft,
  IconInfo,
  IconPaperPlane,
  IconPlusRounded,
  IconData,
  IconTickRounded,
  IconCloseRounded,
} from "@aksara-ui/icons";
import {
  Avatar,
  Badge,
  Box,
  Button,
  Card,
  IconButton,
  Skeleton,
  SkeletonBox,
  Stack,
  Table,
  TableBody,
  TableBodyCell,
  TableBodyRow,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  Text,
  UnstyledButton,
  theme,
} from "@aksara-ui/react";
import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { CatalogGiftAddModal } from "./components";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCatalogGifts,
  getCatalogById,
  setModalFormOpen,
  setModalVerifyKtpOpen,
} from "redux/actions";
import TableBodyRowsSkeleton from "components/TableBodyRowSkeleton";
import { toCapitilizeCase } from "utilities/helper/toCapitalizeCase";
import {
  Pagination,
  PaginationDetail,
  PaginationFilter,
} from "components/Pagination";
import { InputSearchbox } from "components/Form/InputSearchbox";
import LazyLoadImageWithBlurHash from "components/LazyLoadImageWithBlurHash";
import { CatalogStocksContent } from "../CatalogStocks";
import moment from "moment";
import { CatalogGiftDetailsContent } from "./CatalogGiftDetails";
import { stringToColor } from "utilities/helper/stringToColor";
import { KTPVerifiedContent } from "./KTPVerified";

interface Props {
  catalogId?: string | undefined;
}

const CatalogGiftsContent: React.FC<Props> = ({ catalogId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 576 });

  const [searchValue, setSearchValue] = useState("");
  const [limit, setLimit] = useState(10);
  const [selectedCatalogIdForStock, setSelectedCatalogIdForStock] =
    useState<any>("");
  const [openCatalogStocksModal, setOpenCatalogStocksModal] = useState(false);

  const [selectedCheckoutId, setSelectedCheckoutId] = useState("");
  const [openCatalogGiftDetailsModal, setOpenCatalogGiftDetailsModal] =
    useState(false);

  const [selectedUserId, setSelectedUserId] = useState("");

  const { baseUrl, appUrl, isLoading, isModalFormOpen, isModalVerifyKtpOpen } =
    useSelector((state: any) => state.globalReducer);
  const { catalogGifts } = useSelector(
    (state: any) => state.catalogGiftReducer
  );
  const { currentPage, totalPage, limitPage, lengthPage } = useSelector(
    (state: any) => state.catalogGiftReducer
  );
  const { catalogDetail, isCatalogDetailLoading } = useSelector(
    (state: any) => state.catalogReducer
  );

  const handleSearchChange = (event: any) => {
    setSearchValue(event.target.value);
    dispatch(
      getAllCatalogGifts(
        catalogId,
        currentPage,
        event.target.value,
        limitPage
      ) as any
    );
  };

  const handleClearSearchChange = () => {
    setSearchValue("");
    dispatch(getAllCatalogGifts(catalogId, currentPage, "", limitPage) as any);
  };

  const handleOpenAddModal = () => {
    dispatch(setModalFormOpen(true) as any);
  };

  const handleCloseAddModal = () => {
    dispatch(setModalFormOpen(false) as any);
  };

  const handleOpenCatalogStocksModal = (catalogId: string | undefined) => {
    setOpenCatalogStocksModal(true);
    setSelectedCatalogIdForStock(catalogId);
  };

  const handleCloseCatalogStocksModal = () => {
    setOpenCatalogStocksModal(false);
    setSelectedCatalogIdForStock("");
  };

  const handleOpenCatalogGiftDetailsModal = (checkoutId: string) => {
    setOpenCatalogGiftDetailsModal(true);
    setSelectedCheckoutId(checkoutId);
  };

  const handleCloseCatalogGiftDetailsModal = () => {
    setOpenCatalogGiftDetailsModal(false);
    setSelectedCheckoutId("");
  };

  const handleOpenKTPVerifiedModal = (userId: string) => {
    dispatch(setModalVerifyKtpOpen(true) as any);
    setSelectedUserId(userId);
  };

  const handleCloseKTPVerifiedModal = () => {
    dispatch(setModalVerifyKtpOpen(false) as any);
    setSelectedUserId("");
  };

  useEffect(() => {
    if (catalogId) {
      dispatch(getCatalogById(catalogId) as any);
      dispatch(getAllCatalogGifts(catalogId) as any);
    }
  }, [dispatch, catalogId]);

  return (
    <Box height={"100%"} paddingY={20} paddingX={isMobile ? 30 : 50}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        flexDirection={"column"}
        paddingBottom={20}
        style={{ gap: 20 }}
      >
        <Box
          display={"flex"}
          justifyContent={"left"}
          alignItems={"center"}
          style={{ gap: 20 }}
        >
          <Card
            style={{
              backgroundColor: "white",
              borderColor: `${theme.colors.grey04}`,
              borderWidth: 2,
              borderRadius: "50%",
            }}
            elevation={2}
          >
            <UnstyledButton
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              size={35}
              onClick={() => {
                navigate(-1);
              }}
            >
              <IconChevronLeft size={20} />
            </UnstyledButton>
          </Card>

          <Text scale={[500, 600]} fontWeight={700}>
            List User Receive Gift
          </Text>
        </Box>

        <Box>
          <Card
            height={isMobile ? "100%" : 182}
            width={isMobile ? "100%" : 580}
            backgroundColor={"white"}
            borderRadius={10}
            elevation={2}
            borderWidth={1}
          >
            <Box
              paddingY={20}
              paddingX={30}
              display={"flex"}
              // justifyContent={"space-between"}
              justifyContent={"center"}
              flexDirection={isMobile ? "column" : "row"}
              style={{ gap: 20 }}
            >
              <Box
                height={isMobile ? "100%" : 150}
                display={"flex"}
                justifyContent={isMobile ? "center" : "left"}
                alignItems={"center"}
                // width={isCatalogDetailLoading ? 200 : "100%"}
              >
                {isCatalogDetailLoading ? (
                  <SkeletonBox style={{ width: 180, height: 130 }} />
                ) : (
                  <LazyLoadImageWithBlurHash
                    src={`${appUrl}/storage/${catalogDetail.img_url}`}
                    alt="catalog-image"
                    width={192}
                    style={{
                      borderRadius: 20,
                    }}
                  />
                )}
              </Box>

              <Box
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"center"}
                style={{ gap: 15 }}
                width={isCatalogDetailLoading ? 300 : "100%"}
              >
                {isCatalogDetailLoading ? (
                  <Skeleton style={{ width: "100%" }} />
                ) : (
                  <Text fontWeight={500} color={theme.colors.grey06}>
                    Product Information
                  </Text>
                )}
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  style={{ gap: 10 }}
                >
                  {isCatalogDetailLoading ? (
                    <Skeleton style={{ height: 50 }} />
                  ) : (
                    <Text scale={500} fontWeight={700}>
                      {catalogDetail.catalog_name}
                    </Text>
                  )}

                  {isCatalogDetailLoading ? (
                    <Skeleton />
                  ) : (
                    <Text
                      fontWeight={600}
                      color={
                        catalogDetail.available_stock < 1
                          ? theme.colors.red06
                          : theme.colors.green06
                      }
                    >
                      Available Stock {catalogDetail.available_stock}
                    </Text>
                  )}

                  {isCatalogDetailLoading ? (
                    <Skeleton style={{ height: 30 }} />
                  ) : (
                    <Badge size="md" variant={"info"} style={{ height: 30 }}>
                      {catalogDetail.is_voucher
                        ? "Digital Goods"
                        : "Physical Goods"}
                    </Badge>
                  )}
                </Box>
              </Box>
            </Box>
          </Card>
        </Box>

        <Box
          display={"flex"}
          flexDirection={isMobile ? "column" : "row"}
          justifyContent={"space-between"}
          style={{ gap: isMobile ? 10 : 20 }}
        >
          <InputSearchbox
            autoComplete="off"
            name="textDummy"
            placeholder="Search..."
            size={32}
            onChange={handleSearchChange}
            onClearButton={handleClearSearchChange}
          />

          <Stack
            display={"flex"}
            justifyContent={"right"}
            flexDirection={"row"}
            // maxWidth={180}
            style={{ gap: 20 }}
          >
            <Button
              variant="outline"
              borderRadius={10}
              style={{
                fontWeight: 600,
                color: "white",
                backgroundColor: `${theme.colors.green07}`,
              }}
              icon={IconPlusRounded}
              iconPosition={"left"}
              size={32}
              onClick={() => handleOpenCatalogStocksModal(catalogId)}
            >
              Add Stock
            </Button>

            <Button
              variant="primary"
              borderRadius={10}
              style={{ fontWeight: 600 }}
              icon={IconPaperPlane}
              iconPosition={"left"}
              size={32}
              onClick={() => handleOpenAddModal()}
            >
              Send Gift
            </Button>
            <Button
              variant="primary"
              borderRadius={10}
              style={{
                fontWeight: 600,
                backgroundColor: "#FFD700",
                color: "black",
              }}
              icon={IconData}
              iconPosition={"left"}
              size={32}
              onClick={() =>
                (window.location.href =
                  `${baseUrl}/download-excel?catalog_id=` + catalogId)
              }
            >
              Export Excel
            </Button>
          </Stack>
        </Box>
      </Box>

      <Card maxHeight={"100%"} overflow={"auto"} elevation={2}>
        <Table>
          <TableHead position={"sticky"} top={0} backgroundColor={"white"}>
            <TableHeadRow>
              <TableHeadCell>Ancol ID</TableHeadCell>
              <TableHeadCell>Name</TableHeadCell>
              <TableHeadCell>Email</TableHeadCell>
              <TableHeadCell>Phone Number</TableHeadCell>
              <TableHeadCell>E-wallet Number</TableHeadCell>
              <TableHeadCell>Tier</TableHeadCell>
              <TableHeadCell>Portal</TableHeadCell>
              <TableHeadCell>Quantity</TableHeadCell>
              <TableHeadCell>Claimed</TableHeadCell>
              <TableHeadCell>KTP Verified</TableHeadCell>
              <TableHeadCell>Gift Date</TableHeadCell>
              <TableHeadCell>Action</TableHeadCell>
            </TableHeadRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableBodyRowsSkeleton rowsNumber={10} columnsNumber={12} />
            ) : !catalogGifts.length ? (
              <TableBodyRow>
                <TableBodyCell colSpan={12} textAlign={"center"}>
                  No reward available
                </TableBodyCell>
              </TableBodyRow>
            ) : (
              catalogGifts.map((gift: any) => {
                const name = gift.name;
                const color = stringToColor(name);

                return (
                  <TableBodyRow key={gift.id}>
                    <TableBodyCell>{gift.ancol_id}</TableBodyCell>
                    <TableBodyCell whiteSpace={"nowrap"}>
                      <Avatar
                        name={name}
                        backgroundColor={color}
                        style={{ marginRight: 15 }}
                      />
                      {name}
                    </TableBodyCell>
                    <TableBodyCell>{gift.email}</TableBodyCell>
                    <TableBodyCell whiteSpace={"nowrap"}>
                      +62 {gift.phone_number.slice(2)}
                    </TableBodyCell>
                    <TableBodyCell whiteSpace={"nowrap"}>
                      {gift.ewallet_number
                        ? `+62 ${gift.ewallet_number.slice(2)}`
                        : "N/A"}
                    </TableBodyCell>
                    <TableBodyCell whiteSpace={"nowrap"}>
                      <Badge
                        size="md"
                        style={{
                          backgroundImage: `${gift.tier_color}`,
                          color: `${
                            gift.tier_name !== "silver" ? "#FAFBFD" : "#949DA7"
                          }`,
                        }}
                      >
                        {gift.tier_name
                          ? toCapitilizeCase(gift.tier_name)
                          : "-"}
                      </Badge>
                    </TableBodyCell>
                    <TableBodyCell>
                      <Badge size={"md"} variant={"warning"}>
                        {gift.portal}
                      </Badge>
                    </TableBodyCell>
                    <TableBodyCell>{gift.quantity}</TableBodyCell>
                    <TableBodyCell>
                      {gift.is_claimed !== 1 ? (
                        <IconButton size={40} onClick={() => {}}>
                          <IconCloseRounded fill={theme.colors.red06} />
                        </IconButton>
                      ) : (
                        <IconButton size={40} onClick={() => {}}>
                          <IconTickRounded fill={theme.colors.green06} />
                        </IconButton>
                      )}
                    </TableBodyCell>
                    <TableBodyCell>
                      {gift.is_ktp_verified !== 1 ? (
                        <IconButton
                          size={40}
                          onClick={() =>
                            handleOpenKTPVerifiedModal(gift.user_id)
                          }
                        >
                          <IconCloseRounded fill={theme.colors.red06} />
                        </IconButton>
                      ) : (
                        <IconButton
                          size={40}
                          onClick={() =>
                            handleOpenKTPVerifiedModal(gift.user_id)
                          }
                        >
                          <IconTickRounded fill={theme.colors.green06} />
                        </IconButton>
                      )}
                    </TableBodyCell>
                    <TableBodyCell>
                      {moment(gift.date).format("DD MMMM YYYY, HH:mm:ss")}
                    </TableBodyCell>
                    <TableBodyCell>
                      <IconButton
                        size={40}
                        onClick={() =>
                          handleOpenCatalogGiftDetailsModal(gift.id)
                        }
                      >
                        <IconInfo fill={theme.colors.blue06} />
                      </IconButton>
                    </TableBodyCell>
                  </TableBodyRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </Card>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        paddingY={10}
      >
        {!isMobile ? (
          <PaginationDetail
            page={currentPage}
            limit={limitPage}
            length={lengthPage}
          />
        ) : (
          ""
        )}
        <Pagination
          current={currentPage}
          total={totalPage}
          onSelect={(select: any) =>
            dispatch(
              getAllCatalogGifts(
                catalogId,
                select,
                searchValue,
                limitPage
              ) as any
            )
          }
        />
        <PaginationFilter
          selectedItem={limit}
          onChange={(selectedItem) => {
            if (selectedItem) {
              setLimit(selectedItem);
              dispatch(
                getAllCatalogGifts(
                  catalogId,
                  1,
                  searchValue,
                  selectedItem
                ) as any
              );
            }
          }}
          items={[10, 20, 30, 40, 50]}
        />
      </Box>

      <CatalogStocksContent
        catalogId={selectedCatalogIdForStock}
        type={catalogDetail.is_voucher ? "Voucher" : "Catalog"}
        isOpen={openCatalogStocksModal}
        onClose={() => handleCloseCatalogStocksModal()}
      />

      <CatalogGiftAddModal
        catalogId={catalogId}
        isOpen={isModalFormOpen}
        onClose={() => handleCloseAddModal()}
      />

      <CatalogGiftDetailsContent
        checkoutId={selectedCheckoutId}
        type={catalogDetail.is_voucher ? "Voucher" : "Catalog"}
        isOpen={openCatalogGiftDetailsModal}
        onClose={() => handleCloseCatalogGiftDetailsModal()}
      />

      <KTPVerifiedContent
        catalogId={catalogId}
        userId={selectedUserId}
        isOpen={isModalVerifyKtpOpen}
        onClose={() => handleCloseKTPVerifiedModal()}
      />
    </Box>
  );
};

export default CatalogGiftsContent;
